/// <amd-module name="Wiki/MovePageConfirmationDialog/MovePageConfirmationDialog" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { Spinner } from "VSSUI/Spinner";
import { WikiPageMoveResponse, WikiType } from "Wiki/Clients/Wiki/Contracts/Wiki";
import * as Resources from "Wiki/MovePageConfirmationDialog/Resources";
import { TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { publish } from "Wiki/ViewCommon/Utils/WikiHelper";

interface MoveConfirmationDialogProps {
    onSave: () => Promise<WikiPageMoveResponse>;
    onDismiss: () => void;
    wikiType: WikiType;
}

interface MoveConfirmationDialogState {
    isMoving?: boolean;
}

export class MovePageConfirmationDialog extends VssComponent<MoveConfirmationDialogProps, MoveConfirmationDialogState> {
    constructor(props: MoveConfirmationDialogProps, context: IVssComponentContext) {
        super(props, context);
        this.state = {};
    }

    public componentDidMount(): void {
        super.componentDidMount();
        publish(this.context.pageContext, TelemetryConstants.MovePageDialogPrompted, this.props.wikiType);
    }

    public render(): JSX.Element {
        const { onDismiss } = this.props;
        const { isMoving } = this.state;
        return (
            <Dialog
                onDismiss={onDismiss}
                showCloseButton={true}
                titleProps={{ text: Resources.Title }}
                footerButtonProps={[
                    {
                        text: Resources.CancelText,
                        onClick: this._onCancel,
                        disabled: isMoving
                    },
                    {
                        text: Resources.CTAText,
                        onClick: () => {
                            this._onSaveStart();
                        },
                        primary: true,
                        disabled: isMoving
                    }
                ]}
            >
                <span>
                    <span>{Resources.Content}</span>
                    <span> {isMoving ? <Spinner /> : null}</span>
                </span>
            </Dialog>
        );
    }

    private _onSaveStart = (): void => {
        this.setState({ isMoving: true });
        this.trackPromise(this.props.onSave()).promise.then(this.props.onDismiss, () => {
            // TODO : Task 1492899: Error handling for move page confirmation dialog
            this.setState({ isMoving: false });
        });
    };

    private _onCancel = (): void => {
        publish(this.context.pageContext, TelemetryConstants.MovePageDialogDismissed, this.props.wikiType);
        this.props.onDismiss();
    };
}

VssComponent.register("Wiki.MovePageConfirmationDialog", MovePageConfirmationDialog);
